module.exports = "<button\n  class=\"editorUi-btn editorUi-modalFullWidth-btn\"\n  v-tooltip:top=\"!canGenerate ? 'This option is only for hosted sites.' : ''\"\n  :class=\"{\n    'editorUi-disabledBtn': !canGenerate,\n    'editorUi-btn-success': !loading,\n    'admin-btnPublish': !loading,\n   }\"\n  :disabled=\"!canGenerate\"\n  @click.prevent=\"canGenerate ? generateSite() : null\">\n  <span v-if=\"!loading\">Clear Site Cache</span>\n  <drops-loader :show-loader=\"loading\" :size=\"'tiny'\" />\n</button>\n";


//////////////////
// WEBPACK FOOTER
// ./src/global-view/editor/page/top-control-bar/global-options/cache/template.html
// module id = NuCC
// module chunks = 0